import _ from 'lodash';
import {PREFIX, actionMeta} from './meta';
import URLService from 'service/URLService';

const ty = actionMeta.identifiers;

let initState = {
    projects: [],
    projectsLoadedTenant: null,
    projectsLoading: false
};

export default function reducer(state = initState, action = "") {

    //console.log("action:", action.type, " payload:", action.payload)

    if (action.type.startsWith(PREFIX)) {
        switch (action.type) {
            case ty.PROJECTS_LIST_REQUEST:
                if(!action.payload.params.loadInBackground) {
                  state = {
                    ...state,
                    projects: [],
                    projectsLoading: true,
                  }
                }
                break;
            case ty.PROJECTS_LIST_RESPONSE:
                state = {
                    ...state,
                    projects: action.payload.data.projects,
                    projectsLoadedTenant: action.payload.params.tenant_id,
                    projectsLoading: false,
                }
                break;
            case ty.PROJECT_CREATE_RESPONSE:
                state = {
                    ...state,
                    projects: [
                        ..._.filter(state.projects, (t) => t.id!=action.payload.data.id),
                        action.payload.data
                    ]
                }
                URLService.setQueryParameter("project_id", action.payload.data.id)
                break;
            default:
                return state
                break;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/storeState/projects/reducer.js